module.exports = __webpack_public_path__ + "img/79.d2e54c00.jpg";